<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
  html,
  body {
    width: 100%;
    height: 100%;
  }

  * {
    padding: 0;
    margin: 0;
  }
  a{
    text-decoration: none; /* 去掉下划线 */
    color: #000;
  }
</style>
